const psychoanalystSentences = [
  [
    "De acordo com a segunda tópica freudiana, ",
    "A doutrina de Lacan sobre o RSI diz que ",
    "Freud, em correspondência a Jung, cita que ",
    "É imperioso ressaltar que ",
    "A clínica mostra que o início do tratamento ",
    "Cada inconsciente relativo confunde-se, por meio de uma redução operacional, com ",
    "Quando dizemos ao paciente que certa imagem sua significa outra coisa, ",
    "Ao mesmo tempo e de maneira simétrica, ",
    "Freud disse que ",
    "Lacan dirá que ",
    "Não fosse uma claudicação, ",
    "A exterioridade que vige no mais íntimo de nós mesmos, carrega ",
    "O assujeitamento ao Outro reprime ",
    "A psicanálise parte da idéia de que ",
    "Enquanto conceito psicanalítico, ",
    "O desejo portanto, ",
    "O sonho é a realização de um desejo que ",
    "A pulsão é o elo entre o somático e o psíquico onde ",
    "Assim, ",
    "Por outro lado, ",
    "Do mesmo modo, ",
    "Ora, ",
    "Podemos descrever, assim, ",
    "Não hesitamos em comparar que ",
    "Compreendemos cedo que ",
    "Não conseguindo descartar complexos pessoais, ",
    "Mais além do princípio de prazer, ",
    "Não-todo fálico, ",
  ],
  [
    "o nó borromeano que amarra a tripartição estrutural dos registros real, simbólico e imaginário ",
    "a onipresença das fantasias subjacentes ",
    "os processos oníricos — e, por extensão, todo o inconsciente — ",
    "o movimento da pulsão escópica ",
    "o estado amoroso na hipnose ",
    "o limite teórico das ruturas de campo interpretativas ",
    "a nossa subjetivação ",
    "o pai totêmico da horda primeva ",
    "o repúdio ao feminino ",
    "o recalque da enunciação ",
    "o desejo inconsciente ",
    "o delírio ligado à produção de um certo saber, ",
    "a ausência de autoridade ",
    "uma parte valiosa e bem dotada da sociedade ",
    "um exaltado sem organização e nem disciplina ",
    "o princípio suscetível que serve de base ",
    "a tendência sexual inibida ",
    "a foraclusão do significante do Nome-do-Pai ",
    "o polo hostil da ambivalência afetiva do complexo paterno ",
    "o inconsciente estruturado como linguagem ",
    "a pulsão escópica ",
    "o assédio das grandes necessidades orgiânicas ",
    "a defesa frente à inexorabilidade do real ",
  ],
  [
    "é o ponto de fundação de nosso próprio desejo ",
    "aferra o desejo à Coisa ",
    "opera não per via di porre, e sim per via di levare ",
    "modifica a intervenção ",
    "já está implícito no uso contemporâneo da interpretação transferencial ",
    "produz uma marca psíquica ",
    "vela a enunciação ",
    "recusa a castração ",
    "constrói um delírio ",
    "denega a natureza do sofrimento ",
    "realiza a travessia da fantasia ",
    "contribui para a colocação em cena ",
    "fornece a dimensão teórica ",
    "se acompanha então de inconvenientes não negligenciáveis ",
    "foraclui o ponto de fundação ",
    "se vale da tradução metafórica do material ",
  ],
  [
    " sem que isso impeça a extração de gozo.",
    "que delimita o campo de intervenção do analista ",
    "que termina por transformar o objeto em uma instância paranóica.",
    "que leva à convergência no recalque.",
    "cujos efeitos produzem o recalque desta mesma etilogia sexual da neurose.",
    "que faz com que o sujeito se constitua no campo do Outro.",
    "cujo o eu não é senhor em sua própria casa.",
    "quando a angústia é sem objeto.",
    "que não há Outro do Outro.",
    "que não há metalinguagem.",
    "que não há relação sexual.",
    "que a Mulher não existe.",
    "que define o modo de relação do sujeito com o seu sofrimento.",
    "cuja resistência é sempre do analista",
    "da nostalgia da suposta presença da \"Coisa\" que teria nos salvado do desamparo.",
    "que supostamente nos faria pleno.",
    "que deixa brotar de si o Homem Psicanalítico.",
    "revelando-se por fim que o sofrimento em si mesmo é um gozo",
  ]
]

export default psychoanalystSentences;



// WEBPACK FOOTER //
// ./src/psychoanalystSentences.js